import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CookingStoryPageResponce,
  CookingStoryCategories,
  cookingStoryMoreCategorie,
} from 'src/app/core/model/api-response/cooking-story-model';
import { baseUrl } from 'src/app/global-variables';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { UserDataService } from '../user-repository/user-data.service';
import { SuppotTicketsResponce } from '../../../core/model/api-response/support-responce.model';
import { CookingStoryDataService } from './cooking-story-data.service';
import { promise } from 'selenium-webdriver';
import { async } from '@angular/core/testing';

@Injectable({
  providedIn: 'root',
})
export class CookingStoryApiService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private cookingStoryDataService: CookingStoryDataService
  ) {}

  getCookingStoryCategories(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<CookingStoryCategories>(baseUrl + 'api/v2/recipe/category', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({
              cookingStory: result,
            })
          );
        }
      });
  }

  async getCookingStoryPosts(
    catId: string = '5fa50836a89d3d77c8c101e9'
  ): Promise<GenericResponse> {
    let data: GenericResponse;
    return this.cookingStoryDataService
      .getCookingStoryData(catId)
      .then(async (res) => {
        if (res && typeof res !== 'boolean') {
          return new GenericResponse(
            true,
            new GenericResponseData({
              cookingStoryPage: res,
            })
          );
        } else {
          const headerDict = this.userDataService.getHeaderDict();

          return this.http
            .get<CookingStoryPageResponce>(
              baseUrl + 'api/v2/recipe/home?catId=' + catId,
              {
                headers: new HttpHeaders(headerDict),
              }
            )
            .toPromise()
            .then((result) => {
              if (result) {
                this.cookingStoryDataService.saveCategorie(
                  catId,
                  result.suggestion,
                  result.categories
                );

                return new GenericResponse(
                  true,
                  new GenericResponseData({
                    cookingStoryPage: result,
                  })
                );
              }
            });
        }
      });
    return Promise.resolve(data);
  }

  getCokkingStoryMorePost(
    id: string,
    type: string,
    page: number
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<cookingStoryMoreCategorie>(
        baseUrl +
          'api/v2/recipe/home/category/' +
          id +
          '?type=' +
          type +
          '&page=' +
          page,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        return new GenericResponse(
          true,
          new GenericResponseData({
            cookingStoryMorePost: result,
          })
        );
      });
  }

  cookingStorysendRepost(
    text: string,
    recipe: string
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    let body = { text, type: 'recipe', recipeId: recipe };

    return this.http
      .post<SuppotTicketsResponce>(
        baseUrl + 'api/v2/feedback',
        {
          ...body,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ sendMessageResponce: res })
        );
      });
  }
}
